import React, { useRef } from 'react'
import { components } from 'cng-web-lib'
import FormProperties from './OgaCodeFormProperties'
import OgaCodeFieldsPlaceholder from './OgaCodeFieldsPlaceholder'
import { FormProvider, useForm, useFormContext } from 'react-hook-form'
import _ from 'lodash'
import { Divider, Grid, Tooltip } from '@material-ui/core'
import OgaCodeFormProperties from './OgaCodeFormProperties'

const {
  button: { CngButton, CngIconButton }
} = components

const { initialValues } = FormProperties.formikProps

function OgaCodeSection({showNotification}) {

  const { getValues, setValue, watch } = useFormContext()

  const ogaInfo = watch('ogaInfo')

  function handleAddOgaCode(data) {
    const ogaInfo = [...getValues('ogaInfo'), data].map(
      (material, index) => ({ ...material, _id: index + 1 })
    )

    setValue('ogaInfo', ogaInfo)
  }

  function handleDeleteOgaCode(data) {
    const clonedOgaInfo = [...getValues('ogaInfo')].filter((material) =>
      material.id ? material.id !== data.id : material._id !== data._id
    )
    const ogaInfo = clonedOgaInfo.map(
      (material, index) => ({ ...material, _id: index + 1 })
    )

    setValue('ogaInfo', ogaInfo)
  }

  return (
    <Grid container spacing={1}>
      {ogaInfo.map((goods, index) => {
        const isLast = ogaInfo.length === 1
        return (
          <React.Fragment key={goods._id || goods.id || index}>
            <Grid item xs={12}>
              <OgaCodeEntry
                index={index}
                isLast={isLast}
                onAddOgaCode={handleAddOgaCode}
                onDeleteOgaCode={handleDeleteOgaCode}
                ogaInfo={goods}
                showNotification={showNotification}
              />
            </Grid>
            {ogaInfo.length !== index + 1 && (
              <Grid item xs={12}>
                <Divider />
              </Grid>
            )}
          </React.Fragment>
        )
      })}
    </Grid>
  )
}

function OgaCodeEntry(props) {
  const { index, isLast, onAddOgaCode, onDeleteOgaCode, ogaInfo, showNotification } = props

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md>
        <OgaCodeFormProperties.Fields index={index} showNotification={showNotification} />
      </Grid>
      <Grid item xs={12} md='auto'>
        <Grid container spacing={1}>
          <Grid item xs='auto'>
            <Tooltip placement='bottom' title='Add new'>
              <span>
                <CngIconButton
                  icon={['fal', 'plus']}
                  onClick={() => onAddOgaCode(initialValues)}
                  size='small'
                  type='outlined'
                />
              </span>
            </Tooltip>
          </Grid>
          <Grid item xs='auto'>
            <Tooltip placement='bottom' title='Clone'>
              <span>
                <CngIconButton
                  icon={['fal', 'copy']}
                  onClick={() => onAddOgaCode({ ...ogaInfo, id: undefined })}
                  size='small'
                  type='outlined'
                />
              </span>
            </Tooltip>
          </Grid>
          {!isLast && (
            <Grid item xs='auto'>
              <Tooltip placement='bottom' title='Delete'>
                <span>
                  <CngIconButton
                    icon={['fal', 'trash']}
                    onClick={() => onDeleteOgaCode(ogaInfo)}
                    size='small'
                    type='outlined'
                  />
                </span>
              </Tooltip>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}

export default OgaCodeSection
